import styled from 'styled-components';

export const RequirementsPageContainer = styled.div<{ isUseWebSDK: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-width: ${(props) => (props.isUseWebSDK ? '600px' : '632px')};
    margin: ${(props) => (props.isUseWebSDK ? '-16px auto 24px auto' : '52px auto 52px auto;')};
    padding: ${(props) => (props.isUseWebSDK ? '0 0 24px 0;' : '0 16px 52px 16px;')};

    ${(props) => props.theme.breakpointTo.sm} {
        margin: ${(props) => (props.isUseWebSDK ? '0px auto 24px auto' : '52px auto 52px auto;')};
        padding: ${(props) => (props.isUseWebSDK ? '0 0 24px 0;' : '0 16px 96px 16px;')};
    }

    .arrow-icon {
        transform: rotate(180deg);
        cursor: pointer;
    }

    .page {
        &-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        &-title {
            ${(props) => props.theme.typography.h2};
            text-align: center;
            margin: 0;
        }
        &-description {
            ${(props) => props.theme.typography.text};
            color: ${(props) => props.theme.palette.textLight};
            text-align: left;
        }
        &-hidden-elem {
            width: 18px;
        }
    }

    .card {
        display: flex;
        flex-direction: column;
        text-align: left;

        @media (max-width: ${(props) => props.theme.breakPoints.sm}) {
            max-width: 320px;
            justify-content: center;
            align-items: center;
            text-align: center;
        }

        &-container {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 24px;
            max-width: 600px;
            margin: auto;

            @media (max-width: ${(props) => props.theme.breakPoints.sm}) {
                grid-template-columns: 1fr;
            }
        }

        &-img {
            width: 138px;
            height: 108px;
        }

        &-title {
            ${(props) => props.theme.typography.textBold};
            margin-top: 20px;
            margin-bottom: 8px;

            @media (max-width: ${(props) => props.theme.breakPoints.sm}) {
                margin-top: 8px;
            }
        }

        &-description {
            ${(props) => props.theme.typography.text};
            color: ${(props) => props.theme.palette.textLight};

            @media (max-width: ${(props) => props.theme.breakPoints.sm}) {
                text-align: center;
            }
        }
    }

    .divider {
        grid-column: span 2;
        height: 1px;
        background-color: ${(props) => props.theme.palette.primaryA5};

        @media (max-width: ${(props) => props.theme.breakPoints.sm}) {
            display: none;
        }
    }
`;
